import { styled } from '@mui/material';
import { COLORS } from '~/data/ui/colors';
import theme from '~/theme';

const useStyles = (filterHeight: string) => ({
  imageWrapper: {
    marginTop: `calc(${filterHeight} + 50px)`,
    marginBottom: '20.71px',
    [theme.breakpoints.up('md')]: {
    },
  },
  noResultImage: {
    maxWidth: '339px',
    maxHeight: '116.28px',
    [theme.breakpoints.up('md')]: {
      maxWidth: '630.85px',
      maxHeight: '216.39px',
    },
  },
  label: {
    '&.MuiTypography-root': {
      fontSize: '18px',
      lineHeight: '24px',
      [theme.breakpoints.up('md')]: {
        fontSize: '24px',
        lineHeight: '30px',
      },
    },
  },

  clear_all: {
    marginBottom: '20px',
    '&.MuiTypography-root': {
      fontFamily: 'EricaSansFOT',
      fontSize: '18px',
      fontWeight: '600',
      cursor: 'pointer',
      textDecorationLine: 'underline',
      textDecorationStyle: 'solid',
    },
  },
});

export const NoResultImage = styled('img')(() => ({
  maxWidth: '339px',
  maxHeight: '116.28px',
  [theme.breakpoints.up('md')]: {
    maxWidth: '450.85px',
    maxHeight: '216.39px',
  },
}));

export const root: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: `${COLORS.gray.light7}`,
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
};

export const clearButtonsContainerStyle: React.CSSProperties = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '36px 0',
};

export const clearButtonsStyle = {
  margin: '4px',
  [theme.breakpoints.down('sm')]: {
    width: '90vw',
  },
};

export default useStyles;
